import { useEffect, useRef } from "preact/compat";

export const get_nested = (p, o, default_value = null, suffix = '') => {
  let res = p.reduce((xs, x) => (xs && xs[x] ? xs[x] : default_value), o)
  if (suffix && res !== default_value) res += suffix
  return res
}

export const get_nested_plain = (p, o, default_value = null, suffix = '') => {
  if (!p) {
    return null;
  }

  return get_nested(p.replaceAll('[', '.').replaceAll(']', '').split('.'), o, default_value, suffix)
}

export function isOdd(num) { return num % 2; }

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`
}

export function useTimeout(callback, delay) {
  const savedCallback = useRef(callback)
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])
  useEffect(() => {
    if (delay === null) {
      return
    }
    const id = setTimeout(() => savedCallback.current(), delay)
    return () => clearTimeout(id)
  }, [delay])
}

export function preloadImage(src) {
  return new Promise((resolve, reject) => {
    const imgage = new Image();
    imgage.src = src;
    imgage.onload = () => { resolve(imgage) }
    imgage.onerror = imgage.onabort = () => {
      reject(imgage);
    }
  });
}

export const getRandomItems = (items, count) => {
  // hold the picked items and their locations
  const pickedItems = [];
  const pickedIndexs = [];

  // size of array
  let itemsCount = items.length;
  count = count ?? itemsCount;

  // pick the values
  for (let i = 1; i <= count; i++) {
    // choose a random location in the array
    const index = Math.floor(Math.random() * itemsCount);

    // get the value and location
    pickedItems[i] = items[index];
    pickedIndexs[i] = index;

    // replace the picked value with one from the end of the array
    items[index] = items[itemsCount];

    // decrease the size of the array
    itemsCount -= 1;
  }

  // restore the values to array
  for (let i = 1; i <= count; i++) {
    items[pickedIndexs[i]] = pickedItems[i];
  }

  return pickedItems;
}

export const parseUrl = (url) => {
  return new URL(url)
}
